module.exports = __webpack_public_path__ + "static/img/dian_yangan.4c394c45.png";